@for (part of parts(); track part.bgColorClass) {
  <app-sites-table-entities-per-state-cell-part
    class="grow"
    [ngStyle]="{
      width: part.width + 'px',
    }"
    [count]="part.count"
    [bgColorClass]="part.bgColorClass"
    [title]="part.status | appTranslateEvseStatusCapitalized"
  />
}
